var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z",
    fill: "#EFE8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4Z",
    stroke: "#CCB1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 28.24C9.71 28.23 9.71 28.22 9.71 28.22L15.21 22.72C15.22 22.71 15.23 22.71 15.24 22.7C14.61 22.26 13.84 22 13 22C10.79 22 9 23.79 9 26C9 26.75 9.21 27.46 9.58 28.06C9.62 28.12 9.66 28.18 9.7 28.24Z",
    fill: "#9F55FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 23.75C16.29 23.76 16.29 23.77 16.28 23.78L10.78 29.28C10.77 29.29 10.76 29.29 10.75 29.3C11.39 29.74 12.16 30 13 30C14.46 30 15.73 29.22 16.42 28.06C16.79 27.46 17 26.75 17 26C17 25.16 16.74 24.39 16.3 23.75Z",
    fill: "#9F55FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0969 20.1076L14.098 20.1078C16.9788 20.6226 19.0759 23.2836 18.9998 26.1927C18.9891 26.6414 18.9262 27.0808 18.811 27.51H25C26.4234 27.51 27.5331 27.1541 28.2848 26.4561C29.0297 25.7643 29.5 24.6647 29.5 23.01V17C29.5 15.3453 29.0297 14.2457 28.2848 13.5539C27.5331 12.8559 26.4234 12.5 25 12.5H15C13.5766 12.5 12.4669 12.8559 11.7152 13.5539C10.9703 14.2457 10.5 15.3453 10.5 17V20.556L14.0969 20.1076ZM14.0969 20.1076C12.8058 19.8798 11.5733 20.0637 10.5027 20.555L14.0969 20.1076ZM17 20C17 21.6561 18.3439 23 20 23C21.6561 23 23 21.6561 23 20C23 18.3439 21.6561 17 20 17C18.3439 17 17 18.3439 17 20ZM26.5 23.25C27.1861 23.25 27.75 22.6861 27.75 22V18C27.75 17.3139 27.1861 16.75 26.5 16.75C25.8139 16.75 25.25 17.3139 25.25 18V22C25.25 22.6861 25.8139 23.25 26.5 23.25Z",
    fill: "#9F55FF",
    stroke: "#9F55FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceBlocked);
export default __webpack_public_path__ + "static/media/balance_blocked.a9da79de733adc2dfe762316182c21b0.svg";
export { ForwardRef as ReactComponent };